import * as React from 'react';
import { useSelector } from 'react-redux';

import { IBaseQuestionProps, TAnswersState } from '../FormContainer/types/internal';

import { EAnswerField } from '../../types/realtorFormScheme/answerField';

import { IGeoFormValue } from '../GeoContainer/types';
import { TAddressField } from '../FormContainer/types';
import { EFirstOrSecond } from '../../types/demand/firstOrSecond';
import { EDealTypeEx } from '../../types/demand/dealType';
import { selectAbUseExperiments } from '../../selectors/selectAbUseExperiments';
import { getLocationId, isDealPeriodExperiment, ELocationIds } from './utils';

export const HiddenCalculationOfPeriodContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const { answersState, setNextStep, setPrevStep, setAnswersState } = props;
  const { dealPeriodExperimental, address, dealTypeEx, firstOrSecond } = answersState;
  const locationId = address?.value && getLocationId(address?.value as TAddressField | IGeoFormValue);

  const experiments = useSelector(selectAbUseExperiments);

  const isDealPeriodExperimentEnabled = isDealPeriodExperiment(experiments);

  const isExperimentalPeriod = () => {
    const isSecondFlat = firstOrSecond?.value === EFirstOrSecond.Second;
    const isSale = dealTypeEx?.value === EDealTypeEx.Sale;
    const isSatisfyingLocation = !!locationId && Object.values(ELocationIds).includes(locationId);

    return isSecondFlat && isSale && isSatisfyingLocation && isDealPeriodExperimentEnabled;
  };

  const handleNextStep = React.useCallback(() => {
    setAnswersState(prevState => {
      const nextAnswersState: TAnswersState = {
        ...prevState,
        [EAnswerField.DealPeriodExperimental]: {
          answerField: EAnswerField.DealPeriodExperimental,
          value: isExperimentalPeriod().toString(),
        },
      };

      setNextStep(nextAnswersState);

      return nextAnswersState;
    });
  }, [isExperimentalPeriod, setAnswersState, setNextStep]);

  React.useEffect(() => {
    if (dealPeriodExperimental) {
      setPrevStep();
    } else {
      handleNextStep();
    }
  }, [dealPeriodExperimental, setPrevStep, handleNextStep]);

  return null;
};
